---
description: Implement an approved plan step by step with verification.
---

1. Follow the plan in order; complete one step before starting the next.
2. Use write for new files and edit with exact oldString for changes; re-read with read first when unsure of exact text.
3. After each write or edit, read the build report: file, line and column on error, warnings, geometry.
4. Verify sizes with measure and solidity with check; fix deviations before continuing.
5. If the plan conflicts with what read, grep, or check reveal, stop and report the conflict instead of improvising a new design.
6. End with what was built and its verification, not a new plan.
